import axiosInstance from '@/utils/api.js'

var state = {
  trafficClasses: [],
  trafficClassesList: []
}

var getters = {
  TRAFFIC_CLASSES: (state) => {
    return state.trafficClasses
  },
  TRAFFIC_CLASSES_LIST: (state) => {
    return state.trafficClassesList
  }
}

var mutations = {
  SET_TRAFFIC_CLASSES: (state, payload) => {
    state.trafficClasses = payload
  },
  SET_TRAFFIC_CLASSES_LIST: (state, payload) => {
    state.trafficClassesList = payload
  }
}

var actions = {
  GET_TRAFFIC_CLASSES: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/traffic_class?tclass_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TRAFFIC_CLASSES', result.data)
    }
  },
  GET_TRAFFIC_CLASSES_LIST: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/tclasses')
    if (result.status === 200) {
      context.commit('SET_TRAFFIC_CLASSES_LIST', result.data)
    }
  },
  CREATE_TRAFFIC_CLASSES: (context, payload) => {
    return axiosInstance.post('/tariffing/tclasses', payload)
  },
  UPDATE_TRAFFIC_CLASSES: (context, payload) => {
    return axiosInstance.put('/tariffing/tclasses', payload)
  },
  DELETE_TRAFFIC_CLASSES: (context, payload) => {
    return axiosInstance.delete('/tariffing/tclasses?tclass_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/trafficClasses.js